import fetcher from 'api/fetcher';
import { push } from 'connected-react-router';
import { NotificationName } from 'utils/constants/notification';

import { addNotification } from 'store/models/notification';

export default (combinedPayerId, activePayer) => {
    return (dispatch, getState) => {
        const { payer, payerId } = getState().payerDetail;
        const hhPayerId = combinedPayerId.split('-')[0];
        const agreementId = combinedPayerId.split('-')[1];
        const agreementInfo = payer.payers.find(
            (el) => el.hhPayerId === parseInt(hhPayerId, 10) && el.agreementId === agreementId
        );
        const body = {
            agreementId: agreementInfo?.agreementId,
            agreementStartDate: agreementInfo?.agreementStartDate,
            hhPayerId,
            activePayer,
        };

        fetcher
            .put(`/api/v1/backoffice/payers/${payerId}`, body)
            .then(() => {
                dispatch(addNotification(NotificationName.PayersPageUpdatePayerDataSuccess));
                setTimeout(() => dispatch(push(`/new/admin/payers/${payerId}`)), 1000);
            })
            .catch((err) => {
                if (err?.response?.status === 400) {
                    dispatch(addNotification(NotificationName.PayersPageUpdatePayerDataError));
                }
            });
    };
};
